var _path, _circle, _path2, _path3, _line, _path4, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBloodPressure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M4.8,4.8h12.2c1.7,0,3,1.4,3,3V17c0,1.7-1.3,3-3,3H4.8l0,0V4.8L4.8,4.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    cx: 29.6,
    cy: 11.7,
    r: 5.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M14.4,18.6V20c0,3.1,2.5,5.5,5.5,5.5c0,0,0,0,0,0h4.2c3,0,5.5-2.5,5.5-5.5v-8.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M26.9,29.7H31c1.5,0,2.8,1.2,2.8,2.8l0,0c0,1.5-1.2,2.8-2.8,2.8h-4.1c-1.5,0-2.8-1.2-2.8-2.8l0,0C24.1,30.9,25.3,29.7,26.9,29.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    x1: 36.5,
    y1: 32.4,
    x2: 33.8,
    y2: 32.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    d: "M7.5,18.6v2.8c0,6.1,5,11.1,11.1,11.1h5.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 333.3333,
    x1: 10.3,
    y1: 4.8,
    x2: 10.3,
    y2: 15.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPressure);
export default __webpack_public_path__ + "static/media/BloodPressure.0381c40e12358d2b2f279c96778c6cac.svg";
export { ForwardRef as ReactComponent };